<body class="background-violet-500">
    <app-nav-menu></app-nav-menu>

    <div class="container-fluid background p-0" style="height: calc(100% - 75px) !important; overflow-y: auto;">
        <router-outlet></router-outlet>
    </div>

</body>